import buildRequestUrl from "lib/requests/requestUtils";
import athenaClient from "lib/axios/clients";
import groupAspectsByScopeAndTag from "lib/filters/metadata";
import _ from "lodash";

export const addCatalogInfoAsync = (entity, filters) => {
  const url = buildRequestUrl(filters, entity);

  const config = {
    method: "GET",
    url,
  };

  return athenaClient(config);
};

export const fetchCatalogInfo = async () => {
  const asyncAspectsList = async () => {
    const aspects = await addCatalogInfoAsync("columns", {});
    return groupAspectsByScopeAndTag(aspects.data);
  };

  const asyncCategoriesList = async () => {
    const categoriesList = await addCatalogInfoAsync("categories", {});

    return _.keyBy(categoriesList.data, "id");
  };

  const asyncLinesList = async () => {
    const linesList = await addCatalogInfoAsync("lines", {
      expand: ["categories"],
    });

    return _.keyBy(linesList.data, "id");
  };

  const asyncBrandsList = async () => {
    const linesList = await addCatalogInfoAsync("brands", {});

    return _.keyBy(linesList.data, "id");
  };

  const asyncProductsList = async () => {
    const productsList = await addCatalogInfoAsync("products", {
      filters: { is_product_client: 1 },
      expand: ["line", "line.categories"],
    });
    return _.keyBy(productsList.data, "id");
  };

  const asyncCompetitorsList = async () => {
    const competitorsList = await addCatalogInfoAsync("products", {
      filters: { is_product_client: 0 },
      expand: ["line", "line.categories"],
    });

    return _.keyBy(competitorsList.data, "id");
  };

  const asyncCompaniesList = async () => {
    const companiesList = await addCatalogInfoAsync("companies", {});

    return _.keyBy(companiesList.data, "id");
  };

  const asyncRetailersList = async () => {
    const retailersList = await addCatalogInfoAsync("retailers", {
      expand: ["retailer_groups"],
    });

    return _.keyBy(retailersList.data, "id");
  };

  const asyncAreasList = async () => {
    const areasList = await addCatalogInfoAsync("areas", {});

    return _.keyBy(areasList.data, "id");
  };
  const asyncEventsList = async () => {
    const areasList = await addCatalogInfoAsync("events", {});

    return _.keyBy(areasList.data, "id");
  };

  const [
    metadata,
    categories,
    lines,
    brands,
    products,
    competitors,
    companies,
    retailers,
    areas,
    events,
  ] = await Promise.all([
    asyncAspectsList(),
    asyncCategoriesList(),
    asyncLinesList(),
    asyncBrandsList(),
    asyncProductsList(),
    asyncCompetitorsList(),
    asyncCompaniesList(),
    asyncRetailersList(),
    asyncAreasList(),
    asyncEventsList(),
  ]);

  return {
    metadata,
    categories,
    lines,
    brands,
    products,
    competitors,
    companies,
    retailers,
    areas,
    events,
  };
};
